import axios from 'axios';
import { API_CONFIG } from '../config/api';

// Criar instância do Axios
const api = axios.create({
  baseURL: API_CONFIG.baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false,
  timeout: API_CONFIG.timeout,
});

// Interceptor para adicionar o token JWT e CSRF nas requisições
api.interceptors.request.use(
  async config => {
    const token = localStorage.getItem('token');

    // Verificar se token é necessário para esta rota
    const publicRoutes = [
      '/auth/login',
      '/auth/verificar',
      '/csrf/token',
      '/health',
      '/status',
    ];
    const isPublicRoute = publicRoutes.some(route =>
      config.url?.includes(route)
    );

    // Para rotas protegidas, apenas avisar se não há token (não rejeitar)
    if (!isPublicRoute && !token) {
      console.warn('Token de autenticação não encontrado para rota protegida:', config.url);
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Adicionar token CSRF apenas para métodos não seguros (POST, PUT, DELETE, PATCH)
    const unsafeMethods = ['POST', 'PUT', 'DELETE', 'PATCH'];

    if (
      unsafeMethods.includes(config.method?.toUpperCase()) &&
      !isPublicRoute &&
      !config.headers['x-skip-csrf']
    ) {
      try {
        // Importação dinâmica para evitar dependência circular
        const { default: csrfService } = await import('./csrfService');
        const csrfToken = await csrfService.getToken();
        config.headers['x-csrf-token'] = csrfToken;
      } catch (error) {}
    }

    // Remover header personalizado antes de enviar
    if (config.headers['x-skip-csrf']) {
      delete config.headers['x-skip-csrf'];
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar erros de resposta
api.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    // Redirecionar para login apenas se for erro de token JWT, não CSRF
    if (error.response && error.response.status === 401) {
      const errorMessage = error.response.data?.error || '';

      // Se for erro de CSRF, tentar renovar token e repetir requisição
      if (
        errorMessage.includes('CSRF') ||
        error.response.data?.code === 'CSRF_TOKEN_INVALID'
      ) {
        try {
          const { default: csrfService } = await import('./csrfService');
          csrfService.clearToken();
          // Não fazer logout, apenas limpar token CSRF
          return Promise.reject(error);
        } catch (csrfError) {}
      } else {
        // Apenas fazer logout se for erro de JWT
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
